<template>
    <div class="InterTableLoading">

    </div>
</template>

<script>
    export default {
        name: "InterTableLoading"
    }
</script>

<style scoped lang="scss">


</style>
